export default __webpack_public_path__ + "static/media/consulting-by-adera.862d4a49.svg";